import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSocket } from '../contexts/SocketContext';
import { useToast } from '../hooks/useToast';

const MatchingSystem = () => {
  const [isMatching, setIsMatching] = useState(false);
  const navigate = useNavigate();
  const { socket } = useSocket();
  const { showToast } = useToast();

  const startMatching = () => {
    setIsMatching(true);
    socket.emit('start-matching');
  };

  const stopMatching = () => {
    setIsMatching(false);
    socket.emit('stop-matching');
  };

  React.useEffect(() => {
    if (!socket) return;

    socket.on('match-found', ({ sessionId }) => {
      navigate(`/chat/${sessionId}`);
    });

    socket.on('matching-error', (error) => {
      showToast(error.message, 'error');
      setIsMatching(false);
    });

    return () => {
      socket.off('match-found');
      socket.off('matching-error');
    };
  }, [socket, navigate, showToast]);

  return (
    <div className="matching-system">
      <h1>Video Chat</h1>
      <p>Find someone to chat with!</p>
      {!isMatching ? (
        <button className="start-button" onClick={startMatching}>
          Start Matching
        </button>
      ) : (
        <button className="stop-button" onClick={stopMatching}>
          Stop Matching
        </button>
      )}
    </div>
  );
};

export default MatchingSystem; 